import styled from 'styled-components';

const DoubleTagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  gap: 16px;
`;

const NavigationButton = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const NavigationButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

const AddTagsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
`;

const TableEmail = styled.div`
  word-break: break-all;
`;

const TableName = styled.p`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  max-width: 220px;
  overflow: hidden;
`;

const TableHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 32px;
  line-height: 32px;
`;

const CustomRemoveEmptyTableWrapper = styled.div`
  display: flex;
  height: 642px;
  justify-content: center;
`;

export {
  AddTagsWrapper,
  CustomRemoveEmptyTableWrapper,
  DoubleTagsWrapper,
  NavigationButton,
  NavigationButtons,
  TableEmail,
  TableHeader,
  TableName,
  TitleWrapper
};
